module.exports = __webpack_public_path__ + "static/certyfikat_9001_pol-d929ad07087acebb2a801f497e14c45d.pdf";